import React from "react";
import "./style.css";
import NotificationComponent from "../components/Notification/NotificationComponent";

const NotificationPage = () => <NotificationComponent />;

export default NotificationPage;
